import { useState } from 'react';

/** 汎用的なタブアイテムの型 */
export type TabItem<T = string> = {
  /** タブのキー（識別子） */
  value: T;
  /** タブの表示ラベル */
  label: string;
};

/** Tabコンポーネントのprops */
type TabsProps<T = string> = {
  /** タブの一覧 */
  tabs: TabItem<T>[];
  /** 選択されているタブの値 */
  defaultTabValue: T;
};

export const useTab = <T extends string = string>({
  tabs,
  defaultTabValue,
}: TabsProps<T>) => {
  const [selectedTabValue, setSelectedTabValue] = useState<T>(
    defaultTabValue || tabs[0].value
  );

  return {
    selectedTabValue,
    handleClickTab: (tabValue: T) => {
      setSelectedTabValue(tabValue);
    },
  };
};
